<template>
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">
                Academia calls
              </h2>
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add Senior call"
              :href="$router.resolve({ name: 'admin.calls.academy.create', query: { actAs: $route.query.actAs } }).href"
              target="_blank"
            ><i
              data-feather="plus"
            /></a>
            <a
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i
              data-feather="settings"
            /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <div
              v-if="active && active.id"
              class="card card--senior-call-header"
            >
              <div
                class="card-body d-flex align-items-center justify-content-between"
              >
                <div>
                  <div class="row">
                    <div class="col-2 col-sm-2">
                      <b-dropdown
                        variant="link"
                        no-caret
                        toggle-class="p-0"
                        left
                      >
                        <template #button-content>
                          <i data-feather="more-vertical" />
                        </template>
                        <div
                          class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                        >
                          <b-dropdown-item
                            :href="$router.resolve({ name: 'admin.calls.academy.view', params: { id: active.id }, query: { actAs: $route.query.actAs } }).href"
                            target="_blank"
                          >
                            <i
                              class="me-50"
                              data-feather="eye"
                            /> View academy
                            call
                          </b-dropdown-item>
                          <div class="dropdown-divider" />
                          <b-dropdown-item
                            :href="$router.resolve({ name: 'admin.calls.academy.groups', params: { id: active.id }, query: { actAs: $route.query.actAs } }).href"
                            target="_blank"
                          >
                            <i
                              class="me-50"
                              data-feather="user-check"
                            />
                            View evaluator groups
                          </b-dropdown-item>
                          <b-dropdown-item
                            :href="$router.resolve({ name: 'admin.calls.academy.pending', params: { id: active.id }, query: { actAs: $route.query.actAs } }).href"
                            target="_blank"
                          >
                            <i
                              class="me-50"
                              data-feather="user-x"
                            /> Pending
                            evaluators
                          </b-dropdown-item>
                          <b-dropdown-item>
                            <i
                              class="me-50"
                              data-feather="award"
                            /> View
                            ranking
                          </b-dropdown-item>
                          <div class="dropdown-divider" />
                          <b-dropdown-item
                            :href="
                              $router.resolve({
                                name: 'admin.calls.academy.edit',
                                params: { id: active.id },
                              }).href
                            "
                            target="_blank"
                          >
                            <i
                              class="me-50"
                              data-feather="edit-3"
                            /> Edit
                          </b-dropdown-item>
                          <b-dropdown-item @click="duplicateConvo(active.id)">
                            <i
                              class="me-50"
                              data-feather="copy"
                            />
                            Duplicate
                          </b-dropdown-item>
                          <b-dropdown-item>
                            <i
                              class="me-50"
                              data-feather="database"
                            />
                            Logs
                          </b-dropdown-item>
                          <div class="dropdown-divider" />
                          <b-dropdown-item>
                            <i
                              class="me-50"
                              data-feather="bell"
                            />
                            Notifications
                          </b-dropdown-item>
                          <div class="dropdown-divider" />
                          <b-dropdown-item>
                            <i
                              class="me-50"
                              data-feather="trash-2"
                            /> Delete
                          </b-dropdown-item>
                        </div>
                      </b-dropdown>
                      <a
                        href=""
                        class="btn btn-icon btn-light-secondary d-block d-sm-none"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasMenu"
                        aria-controls="offcanvasBottom"
                      ><i
                        data-feather="more-vertical"
                      /></a>
                    </div>
                    <div class="col-10 col-sm-10">
                      <h1>
                        <small>Active call</small> {{ active.title }}
                        <span>
                          <template v-for="(area, index) in active.areas">
                            {{ !area.parent_id ? (area.code + (index < active.areas.length - 1 ? ", " : " ")) : null }}
                          </template>
                        </span>
                      </h1>
                    </div>
                  </div>
                </div>
                <div class="card--senior-call-section">
                  <strong>0/{{ active.stats.applicants }}
                    <a
                      class="btn btn-icon btn-flat-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasApplicants"
                      aria-controls="offcanvasApplicants"
                    ><i data-feather="eye" /></a></strong>Applicants
                </div>
                <div class="card--senior-call-section">
                  <strong>{{ active.stats.evaluators }}
                    <a
                      href=""
                      class="btn btn-icon btn-flat-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasEvaluators"
                      aria-controls="offcanvasEvaluators"
                    ><i data-feather="eye" /></a></strong>Evaluators
                </div>
                <div class="card--senior-call-section">
                  <strong>{{ active.stats.feedback }}
                    <a
                      href=""
                      class="btn btn-icon btn-flat-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasFeedbackEditors"
                      aria-controls="offcanvasFeedbackEditors"
                    ><i data-feather="eye" /></a></strong>Feedback editors
                </div>
                <div
                  class="card--senior-call-change-status d-flex align-items-center justify-content-between"
                >
                  <div class="avatar bg-light-warning me-1">
                    <div class="avatar-content">
                      <a
                        class="text-warning"
                      ><i
                        class="avatar-icon"
                        data-feather="git-pull-request"
                      /></a>
                    </div>
                  </div>
                  <div><strong>1st round </strong><small>Status</small></div>
                </div>
              </div>
            </div>
            <CompleteTable
              :sorted-field="sortedField"
              :data="convos"
              :sort-mapping="sortMapping"
              :title="'archived academia calls'"
              :total="totalConvos"
              :fetch-path="'convo/fetchAll'"
              :export-path="'convo/export'"
              :repeaters-view="true"
              :filter-path="'convo/fetchAcademy'"
            >
              <template v-slot="{field}">
                <td
                  class="text-end"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="p-0"
                    right
                  >
                    <template #button-content>
                      <i data-feather="more-vertical" />
                    </template>
                    <div
                      class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
                    >
                      <b-dropdown-item
                        :href="$router.resolve({ name: 'admin.calls.academy.view', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="eye"
                        /> View candidates
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item
                        :href="$router.resolve({ name: 'admin.calls.academy.groups', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="user-check"
                        />
                        View evaluator groups
                      </b-dropdown-item>
                      <b-dropdown-item
                        :href="$router.resolve({ name: 'admin.calls.academy.pending', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="user-x"
                        /> Pending
                        evaluators
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <i
                          class="me-50"
                          data-feather="award"
                        /> View ranking
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item
                        :href="
                          $router.resolve({
                            name: 'admin.calls.academy.edit',
                            params: { id: field.id },
                          }).href
                        "
                        target="_blank"
                      >
                        <i
                          class="me-50"
                          data-feather="edit-3"
                        /> Edit
                      </b-dropdown-item>
                      <b-dropdown-item @click="duplicateConvo(field.id)">
                        <i
                          class="me-50"
                          data-feather="copy"
                        />
                        Duplicate
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <i
                          class="me-50"
                          data-feather="database"
                        />
                        Logs
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item>
                        <i
                          class="me-50"
                          data-feather="bell"
                        />
                        Notifications
                      </b-dropdown-item>
                      <div class="dropdown-divider" />
                      <b-dropdown-item>
                        <i
                          class="me-50"
                          data-feather="trash-2"
                        /> Delete
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                  <a
                    href=""
                    class="btn btn-icon btn-light-secondary d-block d-sm-none"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMenu"
                    aria-controls="offcanvasBottom"
                  ><i
                    data-feather="more-vertical"
                  /></a>
                </td>
              </template>
              <template #customfilters>
                <div class="mb-1">
                  <label
                    for="nameseniorcall"
                    class="form-label"
                  >Candidate</label>
                  <input
                    v-model="filters.candidate"
                    type="text"
                    class="form-control"
                    name="nameseniorcall"
                    @change="saveFilter({ customLabel: true, name: `Candidate: ${$event.target.value}`, value: `${$event.target.value}` }, 'candidate')"
                  >
                </div>
                <div class="mb-1">
                  <label
                    for="areaseniorcall"
                    class="form-label"
                  >Area</label>
                  <v-select
                    v-if="areas.length !== undefined"
                    v-model="filters.areas"
                    multiple
                    label="name"
                    :options="areas"
                    :get-option-key="option => option.id"
                    @input="saveFilter({ customLabel: true, name: `Areas: ${$event ? ($event.map(e => e.name)).join(' - ') : ''}`, value: $event }, 'areas')"
                  >
                    <option
                      value=""
                      selected
                    >
                      All areas
                    </option>
                  </v-select>
                </div>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import vSelect from 'vue-select'
import CompleteTable from '../../partials/components/CompleteTable.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    CompleteTable,
    vSelect,
  },
  data() {
    return {
      sortedField: 'Title',
      defaultFields: [
        {
          name: 'Title',
          checked: true,
          order: 1,
        },
        {
          name: 'Year',
          checked: true,
          order: 2,
        },
        {
          name: 'Acronym',
          checked: true,
          order: 3,
        },
        {
          name: 'Status',
          checked: true,
          order: 4,
        },
        {
          name: 'Applicants',
          checked: true,
          order: 5,
        },
        {
          name: 'Evaluators',
          checked: true,
          order: 6,
        },
        {
          name: 'Pending applications',
          checked: true,
          order: 8,
        },
        {
          name: 'Areas call',
          checked: true,
          order: 10,
        },
      ],
      sortMapping: {
        Title: 'title',
        Acronym: 'code',
        Year: 'year',
        Status: 'status',
        Applicants: 'stats.applicants',
        Evaluators: 'stats.evaluators',
        'Pending applications': 'stats.pending_applications',
        'Areas call': 'areas',
      },
    }
  },
  computed: {
    ...mapGetters({
      convos: 'convo/academyConvos',
      areas: 'areas/areas',
      active: 'convo/convo',
      filters: 'filters/filters',
      fields: 'modals/tableSettingsFields',
      totalConvos: 'convo/totalAcademyConvos',
    }),
  },
  async mounted() {
    this.fetchConvos()
    if (this.areas.length === 0) {
      this.$store.dispatch('areas/filter', this.$store.getters['filters/filters'])
    }
    await this.$store.dispatch('modals/fetchUserFields', 'academy-calls')
    if (!this.fields || this.fields.length === undefined) {
      // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'academy-calls',
      })
    }
  },
  methods: {
    async fetchConvos() {
      await this.$store.dispatch('convo/fetchAcademy', this.$store.getters['filters/filters'])
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      })
    },
    async exportConvos() {
      await this.$store.dispatch('convo/export')
    },
    saveFilter(value, field) {
      if (!value || (!value.value || (value.value === 'null' || (Array.isArray(value.value) && !value.value.length)))) {
        this.$store.dispatch('filters/deleteFilters', field)
      } else {
        this.$store.dispatch('filters/saveFilters', {
          value,
          field,
        })
      }
    },
    async duplicateConvo(id) {
      await this.$store.dispatch('convo/duplicate', id)
      await this.$store.dispatch('convo/fetchAll', 'academy')
    },
  },
}
</script>
